import Box from "@subly/s1/ui/atom/Box";
import Button from "@subly/s1/ui/base/Button";

type Props = {
	canSubmit: boolean;
	isSubmitting: boolean;
	onClick: ({ type }: { type: "back" | "next" }) => void
};

export default function Actions({ canSubmit, isSubmitting, onClick }: Props) {
	return (
		<Box gap={1.25} sx={{ p: 2 }}>
			<Button variant="outlined" color="primary" fullWidth disabled={!canSubmit} loading={isSubmitting} onClick={() => onClick({ type: "back" })}>
				Back
			</Button>
			<Button variant="contained" color="secondary" fullWidth disabled={!canSubmit} loading={isSubmitting} onClick={() => onClick({ type: "next" })}>
				Next
			</Button>
		</Box>
	);
}